// Copyright © 2025 The Things Industries B.V.

import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Breadcrumb from '@ttn-lw/components/breadcrumbs/breadcrumb'
import { useBreadcrumbs } from '@ttn-lw/components/breadcrumbs/context'

import RequireRequest from '@ttn-lw/lib/components/require-request'

import LabelEntitiesList from '@console/containers/label-entities-list/index.tti'

import Require from '@console/lib/components/require'

import { mayViewLabelInfo } from '@console/lib/feature-checks'

import { getLabel } from '@console/store/actions/labels.tti'
import { getGatewaysList } from '@console/store/actions/gateways'
import { getApplicationsList } from '@console/store/actions/applications'

import { selectSelectedLabel } from '@console/store/selectors/labels.tti'

const Label = () => {
  const params = useParams()
  const labelId = params.labelId

  const actions = useMemo(
    () => [
      getLabel(labelId, ['entities']),
      getGatewaysList({ label_id_contains: labelId }, ['name', 'description', 'created_at'], {
        isSearch: true,
      }),
      getApplicationsList({ label_id_contains: labelId }, ['name', 'description', 'created_at'], {
        isSearch: true,
      }),
    ],
    [labelId],
  )
  const label = useSelector(selectSelectedLabel)
  const hasLabel = Boolean(label)

  return (
    <Require featureCheck={mayViewLabelInfo} otherwise={{ redirect: '/' }}>
      <RequireRequest requestAction={actions} requestOnChange>
        {hasLabel && <LabelInner />}
      </RequireRequest>
    </Require>
  )
}

const LabelInner = () => {
  const { labelId } = useParams()

  const label = useSelector(selectSelectedLabel)
  const name = label.name || labelId
  useBreadcrumbs(
    'overview.labels.single',
    <Breadcrumb path={`/labels/${labelId}`} content={name} />,
  )

  return <LabelEntitiesList labelName={name} labelId={labelId} />
}

export default Label
